import { render, staticRenderFns } from "./0005.vue?vue&type=template&id=87dc172e&scoped=true&"
import script from "./0005.vue?vue&type=script&lang=js&"
export * from "./0005.vue?vue&type=script&lang=js&"
import style0 from "./0005.vue?vue&type=style&index=0&id=87dc172e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dc172e",
  null
  
)

export default component.exports